import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { CKButton } from 'clearkit';

import Logo from '~/components/ConfigurationLogo';
import LoadingArea from '~/components/LoadingArea';
import { authConnector } from '~/lib/client';
import {
  connectorLocations,
  trackAuthStartedAccountConnector,
  trackConnectedAccountConnector,
  trackOnboardingConnectorSetupComplete,
  trackSyncEnabledAccountConnector,
} from '~/lib/segmentAnalytics';

import styles from './styles.js';
import TabLabel from './TabLabel';
import Hubspot from './tabs/Hubspot';
import Salesforce from './tabs/Salesforce';

// Groups salesforcesandbox in with salesforce
const normalizeConnectors = (accountConnectors) => {
  const normalized = {};

  accountConnectors.forEach((accountConnector) => {
    if (accountConnector.service === 'salesforcesandbox') {
      normalized['salesforce'] = accountConnector;
    } else {
      normalized[accountConnector.service] = accountConnector;
    }
  });

  return normalized;
};

const ConnectServices = (props) => {
  const [currentTab, setCurrentTab] = useState(0);

  const connect = (connectorType) => {
    trackAuthStartedAccountConnector(
      connectorType,
      connectorLocations.onboarding,
    );
    authConnector(connectorType, () => authSuccess(connectorType));
  };

  const authSuccess = (connectorType) => {
    const { onSuccess, handleNext } = props;
    const normalizedConnectorType =
      connectorType === 'salesforcesandbox' ? 'salesforce' : connectorType;

    trackConnectedAccountConnector(
      normalizedConnectorType,
      connectorLocations.onboarding,
    );
    trackSyncEnabledAccountConnector(
      normalizedConnectorType,
      connectorLocations.onboarding,
    );

    trackOnboardingConnectorSetupComplete(normalizedConnectorType);

    onSuccess();
    handleNext();
  };

  const {
    classes,
    accountConnectors,
    handleNext,
    loading,
    prefetching = false,
  } = props;

  const normalizedConnectors = normalizeConnectors(accountConnectors);
  const hasAnyActiveConnectors = Object.keys(normalizedConnectors).length;

  if (loading && !prefetching) return <LoadingArea loading />;

  return (
    <>
      <div className={classes.stepContent}>
        <Tabs
          value={currentTab}
          onChange={(_, index) => setCurrentTab(index)}
          orientation="vertical"
          classes={{
            root: classes.tabs,
            indicator: classes.tabsIndicator,
            flexContainer: classes.tabsFlexContainer,
          }}>
          <Tab
            icon={
              <div className="flex-shrink-0">
                <Logo type="salesforce" className={classes.tabLogo} />
              </div>
            }
            classes={{
              root: classes.tab,
              wrapper: classes.tabWrapper,
              selected: classes.tabSelected,
              labelContainer: classes.tabLabelContainer,
            }}
            label={
              <TabLabel
                service="salesforce"
                connector={normalizedConnectors.salesforce}
              />
            }
          />
          <Tab
            icon={
              <div className="flex-shrink-0">
                <Logo type="hubspot" className={classes.tabLogo} />
              </div>
            }
            classes={{
              root: classes.tab,
              wrapper: classes.tabWrapper,
              selected: classes.tabSelected,
              labelContainer: classes.tabLabelContainer,
            }}
            label={
              <TabLabel
                service="hubspot"
                connector={normalizedConnectors.hubspot}
              />
            }
          />
        </Tabs>
        <div className={classes.servicePanel}>
          {currentTab === 0 ? (
            <Salesforce
              connector={normalizedConnectors.salesforce}
              connect={connect}
            />
          ) : (
            <Hubspot
              connector={normalizedConnectors.hubspot}
              connect={connect}
            />
          )}
        </div>
      </div>
      <div className="flex flex-col text-center space-y-4">
        <div>
          <CKButton
            isLoading={prefetching}
            isDisabled={!hasAnyActiveConnectors}
            variant="bold"
            variantColor="blue"
            onClick={handleNext}>
            I’m finished connecting services
          </CKButton>
        </div>
        <div>
          <CKButton variant="tertiary" isSmall onClick={handleNext}>
            Skip &amp; connect services later
          </CKButton>
        </div>
      </div>
    </>
  );
};

ConnectServices.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  handleNext: PropTypes.func.isRequired,
  accountConnectors: PropTypes.array,
  loading: PropTypes.bool,
  prefetching: PropTypes.bool,
};

export default withStyles(styles)(ConnectServices);
